export const PaymentApi = {
    getWallets:"/api/bridge/wallets",
    applyCoupon:"/api/bridge/coupon",
    pay : "/api/bridge/pay"
}

export const CourseApi = {
    getCourseList:"/api/package-info",
}
